import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Roles } from "../enums/enums";
import { AirFreightRoles } from "../enums/enums";
import { Observable } from "rxjs/Observable";
import { Constants } from "../constants/constants";

import { PurchaseHistoryService } from "../purchaseHistory/purchaseHistory.service";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

@Injectable()
export class AuthGuardBase implements CanActivate {
	constructor(private role: number, private constants: Constants, private router: Router, private service?: PurchaseHistoryService) { }

	canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): boolean | Observable<boolean> {

        var route = activatedRouteSnapshot.routeConfig.path;
        
		var id = activatedRouteSnapshot.params["approvalId"];

		if (!localStorage.getItem("returnUrl"))
			localStorage.setItem("returnUrl", routerStateSnapshot.url);

		if (!this.constants.user || !this.role) {
			this.router.navigate(["/"]);

			return false;
		}

		let valid: boolean | Observable<boolean>;


        if (route.includes("airQuote") || route.includes("airTraffic")) {

            if (AirFreightRoles.Edit === this.role)
                return ((this.constants.user.airfreightrole & AirFreightRoles.Traffic) === AirFreightRoles.Traffic);
            else
                valid = (this.constants.user.airfreightrole & this.role) === this.role;

            if (!valid)
                this.router.navigate([""]);
        }
        else {

            if (Roles.Edit === this.role)
                return (this.constants.user.role & Roles.Purchaser) === Roles.Purchaser || this.service.canEditPurchase(this.constants.user.username, id);
            else
                valid = (this.constants.user.role & this.role) === this.role;

            if (!valid)
                this.router.navigate([""]);
        }
		return valid;
    }
   
}

@Injectable()
export class DefaultAirFreightAuth extends AuthGuardBase {
    constructor(constants: Constants, router: Router) {
        super(AirFreightRoles.Default, constants, router);
    }
}

@Injectable()
export class AirFreightPurchaserAuth extends AuthGuardBase {
    constructor(constants: Constants, router: Router) {
        super(AirFreightRoles.Default, constants, router);
    }
}

@Injectable()
export class AirFreightTrafficMemberAuth extends AuthGuardBase {
    constructor(constants: Constants, router: Router) {
        super(AirFreightRoles.Traffic, constants, router);
    }
}

@Injectable()
export class AirFreightQuoteApproverAuth extends AuthGuardBase {
    constructor(constants: Constants, router: Router) {
        super(AirFreightRoles.BudgetManager, constants, router);
    }
}

@Injectable()
export class AirFreightEditAuth extends AuthGuardBase {
    constructor(constants: Constants, router: Router) {
        super(AirFreightRoles.Edit, constants, router);
    }
}





@Injectable()
export class DefaultAuth extends AuthGuardBase {
	constructor(constants: Constants, router: Router, service: PurchaseHistoryService) {
		super(Roles.Default, constants, router, service);
	}
}

@Injectable()
export class BudgetManagerAuth extends AuthGuardBase {
	constructor(constants: Constants, router: Router) {
		super(Roles.BudgetManager, constants, router);
	}
}

@Injectable()
export class PurchaserAuth extends AuthGuardBase {
	constructor(constants: Constants, router: Router) {
		super(Roles.Purchaser, constants, router);
	}
}

@Injectable()
export class EditAuth extends AuthGuardBase {
	constructor(constants: Constants, router: Router, service: PurchaseHistoryService) {
		super(Roles.Edit, constants, router, service);
	}
}

@Injectable()
export class ApManagerAuth extends AuthGuardBase {
	constructor(constants: Constants, router: Router) {
		super(Roles.ApMangaer, constants, router);
	}
}